<template>
              <v-menu offset-y allow-overflow>
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                      label="Add more..."
                      v-model="searchItem"
                      class="headline"
                      v-bind="attrs"
                      v-on="on"
                      clearable
                      color="blue"
                      prepend-inner-icon="category"
                      dense
                  ></v-text-field>
                </template>
                <v-list v-if="this.filteredList.length === 0">
                  <v-list-item
                      @click="customItem()"
                  >
                    <v-list-item-title>{{searchItem}}</v-list-item-title>
                  </v-list-item>
                </v-list>
                <v-list v-if="this.filteredList.length !== 0">
                  <v-list-item
                      v-for="(item, index) in filteredList"
                      :key="index"
                      @click="itemPicked(item)"
                  >
                    <v-list-item-title>{{ item.title }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
</template>
<script>
import {v1 as uuidv1} from "uuid";
import {collection, onSnapshot} from "firebase/firestore";

export default {
  name: 'addOnItemPicker',
  props: ['publicListingId', 'listingId'],
  data: () => ({
    searchItem: '',
    addOnItems: null,
  }),
  computed: {
    user () {
      return this.$store.getters.user
    },
    error () {
      return this.$store.getters.error
    },
    loading () {
      return this.$store.getters.loading
    },
    filteredList () {
      if (this.addOnItems) {
        return this.addOnItems.filter((item) => {
          return item.title.toLowerCase().match(this.searchItem.toLowerCase())
        })
      } else return []
    }
  },
  created () {
    // console.log(this.listingId)
    // console.log(this.publicListingId)
    let db = this.$store.state.db
    let listingRef = collection(db, 'publicListings',
        this.publicListingId
        + '/listings/' + this.listingId
        + '/addOnItems')
    onSnapshot(listingRef, res => {
      if (res && res.empty !== true) {
        let items = []
        res.forEach(item => {
          items.push(item.data())
        })
        this.addOnItems = items;
        // console.log(this.addOnItems)
      }
      this.$store.dispatch('setLoading', false)
    })
  },
  methods: {
    itemPicked (item) {
      this.searchItem = ''
      let newItem = {...item}
      newItem.qty = 1
      newItem.id = uuidv1()
      this.$emit('itemFound', newItem)
      // this.quoteData.addOnItems.push(newItem)
      // this.reCalculateItemCost()
      // this.updateQuote()
    },
    customItem () {
      // console.log(this.searchItem)
      let newItem = {
        created: Date.now(),
        id: uuidv1(),
        customAddOnItem: true,
        imgs:[],
        instruction: '',
        listed: false,
        note: '',
        qty: 1,
        title: this.searchItem,
        timeFactor: '35',
        travelFactor: '2'
      }
      // this.quoteData.addOnItems.push(newItem)
      // this.reCalculateItemCost()
      // this.updateQuote()
      // console.log(newItem)
      this.searchItem = ''
      this.$emit('itemFound', newItem)

    },
    onDismissed () {
      this.$store.dispatch('clearError')
    }
  }

}
</script>

